// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__8oEKh","signatureButtonsRight":"ModalSign_signatureButtonsRight__3IDXf"};